module.exports = __webpack_public_path__ + "static/media/chevron-right.cb34201e.svg";